import crawlContent from '@/seo/crawl-content.json';

const SITE_URL = crawlContent.siteUrl;
const DEFAULT_IMAGE = crawlContent.image;

/**
 * Indexable robots directive. Single editable source: src/seo/crawl-content.json
 * (`defaultRobots`). public/index.html should match that value for the first paint;
 * we snapshot the live <meta name="robots"> once on first applySeo so a later
 * route-level noindex cannot become the "default" when navigating away.
 */
let defaultRobotsSnapshot = null;

function getDefaultRobots() {
  if (defaultRobotsSnapshot) return defaultRobotsSnapshot;
  const el =
    typeof document !== 'undefined' &&
    document.head &&
    document.head.querySelector('meta[name="robots"]');
  const fromDom = el && el.getAttribute('content');
  defaultRobotsSnapshot = fromDom || crawlContent.defaultRobots;
  return defaultRobotsSnapshot;
}

function ensureMeta(attr, key, content) {
  if (content === undefined || content === null || content === '') return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function ensureLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Update document title and common discoverability meta tags for the active route.
 * Always sets robots (defaults to the snapshotted indexable directive) so
 * route-level noindex cannot stick after navigating away.
 */
export function applySeo({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  robots,
} = {}) {
  const defaultRobots = getDefaultRobots();
  const fullTitle = title || 'Cashless FYI | Free Cashless Program ROI Calculators';
  const desc =
    description ||
    'Free, vendor-neutral ROI calculators for cashless programs in healthcare, senior living, and corporate dining.';
  const url = `${SITE_URL}${path === '/' ? '/' : path}`;

  document.title = fullTitle;

  ensureMeta('name', 'description', desc);
  ensureMeta('name', 'robots', robots || defaultRobots);
  ensureMeta('property', 'og:title', fullTitle);
  ensureMeta('property', 'og:description', desc);
  ensureMeta('property', 'og:url', url);
  ensureMeta('property', 'og:type', type);
  ensureMeta('property', 'og:image', image);
  ensureMeta('name', 'twitter:title', fullTitle);
  ensureMeta('name', 'twitter:description', desc);
  ensureMeta('name', 'twitter:image', image);
  ensureLink('canonical', url);
}

/**
 * Remove the static crawlable landing once Vue has taken over the UI.
 */
export function removeSeoLanding() {
  const el = document.getElementById('seo-landing');
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

const DEFAULT_ROBOTS = crawlContent.defaultRobots;

export { SITE_URL, DEFAULT_ROBOTS, getDefaultRobots };
